export default {
  businessLogisticsCompanyMapping: {
    header: {
      thirdPartyEncoding: 'Third-party Code',
      thirdPartyLogisticsName: 'Third-party logistics name',
      platformName: 'Platform Name'
    },
    table: {
      businessName: 'Courier Service Name',
      thirdPartyEncoding: 'Third-party Code',
      thirdPartyLogisticsName: 'Third-party logistics name',
      thirdPartyLogisticsPlatform: 'Third-party logistics platform',
    },
    dialog: {
      logisticsCompanyName: 'Logistics provider name',
      businessName: 'Courier Service Name',
      businessNameRulesText: 'Please select logistics provider',
      businessNameSelect: 'Please select business name',
      thirdPartyEncoding: 'Third-party code',
      thirdPartyPlatform: 'Third-party Platform',
      thirdPartyLogisticsName: 'Three-party Logistics Name',
      thirdPartyLogisticsPlatform: 'Three-party Logistics Platform',
      table: {
        thirdPartyEncodingRulesText: 'Please select business name',
        thirdPartyLogisticsNameRulesText: 'Please select logistics provider name',
        thirdPartyLogisticsPlatformRulesText: 'Please enter the third-party logistics platform',
        businessNameSelect: 'Please select business name',
        businessNameRulesText: 'Please select logistics provider name',
      },
      editLogisticsMapping: 'Edit Logistics Mapping',
      addLogisticsMapping: 'Add Logistics Mapping',
    },
  }
};
